import { observer } from 'mobx-react';

import { isSportMonetizationCurrentEvent, MonetizationEventsEventType } from '../../../dto/monetization-events.types';
import type { MonetizationEventsCurrentEvent } from '../../../dto/monetization-events.types';
import { devError } from '../../../utils/log';
import { SportsWidget } from '../SportsDialog/SportsWidget';

import './MonetizationEvents.scss';

export const MonetizationEventWidget = observer(({ event }: { event: MonetizationEventsCurrentEvent }) => {
  switch (event.providerType) {
    case MonetizationEventsEventType.SPORTS:
      if (isSportMonetizationCurrentEvent(event)) {
        return <SportsWidget event={event} />;
      }

      return null;

    case MonetizationEventsEventType.METAGAMES:
      return <div>TODO</div>;
    default:
      devError(`MonetizationEventWidget onClickHandler error: Unknown event type ${event.providerType}`);
      return null;
  }
});
